import * as React from "react";
import { TableRow, TableCell, Button, Modal, Typography, Box, Link } from "@mui/material";
import { connect } from "react-redux";
import { centered_flex_box, main_button } from "../../../app/components/Styles";
import {
  acceptTicketRequest,
  fulfillTicketRequest,
  rejectTicketRequest,
} from "../../../app/store/actions/adminActions";
import ActionDialog from "../../../app/components/ActionDialog";
import moment from "moment";
import { Image, notification } from "antd";

export const RequestRow = ({
  request,
  action,
  setAction,
  acceptTicketRequest,
  fulfillTicketRequest,
  rejectTicketRequest,
}) => {
  const [fulfillDialog, setFulfillDialog] = React.useState(false);
  const [rejectDialog, setRejectDialog] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [detailsOpen, setDetailsOpen] = React.useState(false);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const formatInfoKey = (key) =>
    key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (char) => char.toUpperCase())
      .trim();

  const handleAccept = async (request) => {
    await acceptTicketRequest({ requestId: request._id, eventId: request.event._id });
    await timeout(500);
    setAction(!action);
    notification.success({
      message: "Ticket request accepted successfully",
    });
  };

  const handleReject = async (request) => {
    setRejectDialog(false);
    await rejectTicketRequest({ requestId: request._id, eventId: request.event._id });
    await timeout(500);
    setAction(!action);
  };

  const handleFulfill = async (request) => {
    fulfillTicketRequest({
      requestId: request._id,
      eventId: request.event._id,
      ticketId: request.ticket._id,
    });
    await timeout(500);
    setAction(!action);
  };

  return (
    <>
      <TableRow
        key={request._id}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        {/* <TableCell component="th" scope="row">
          {request._id}
        </TableCell> */}
        <TableCell align="left">{request.userInfo.name}</TableCell>
        <TableCell align="left">{request.userInfo.email}</TableCell>
        <TableCell align="left">{request.userInfo.phoneNumber}</TableCell>
        <TableCell align="left">{moment(request.deadline).fromNow()}</TableCell>
        <TableCell align="left">{request.category}</TableCell>
        <TableCell align="left">{request.status}</TableCell>
        <TableCell align="left">
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 0.5, flexWrap: 'wrap' }}>
            {request.status === "Unseen" && (
              <Button
                onClick={() => handleAccept(request)}
                sx={{ ...main_button, m: { xs: 0.25, sm: 1 } }}
              >
                Accept
              </Button>
            )}
            {request.status !== "Purchased" && request.status !== "Rejected" && (
              <Button
                onClick={() => setRejectDialog(true)}
                sx={{ ...main_button, m: { xs: 0.25, sm: 1 } }}
              >
                Reject
              </Button>
            )}
            {request.status === "Accepted" &&
              request.event.paymentMethod === "InstaPay" && request.instapayUser && (
                <Button
                  onClick={() => setOpen(true)}
                  sx={{ ...main_button, m: { xs: 0.25, sm: 1 } }}
                >
                  View Receipt
                </Button>
              )}
            {request.status === "Accepted" &&
              (request.event.paymentMethod === "Cash" || request.event.paymentMethod === "InstaPay") && (
                <Button
                  onClick={() => setFulfillDialog(true)}
                  sx={{ ...main_button, m: { xs: 0.25, sm: 1 } }}
                >
                  Validate Ticket
                </Button>
              )}
            <Button
              onClick={() => setDetailsOpen(true)}
              sx={{ ...main_button, m: { xs: 0.25, sm: 1 } }}
            >
              View Details
            </Button>
          </Box>
        </TableCell>
      </TableRow>
      <ActionDialog
        open={rejectDialog}
        handleClose={() => setRejectDialog(false)}
        handleAccept={() => handleReject(request)}
        title={`Are you sure you want to reject ${request.userInfo.name}'s request?`}
        content={"Rejecting their request will notify them and delete their ticket if one is already issued. This action is irreversible"}
      />
      <ActionDialog
        open={fulfillDialog}
        handleClose={() => setFulfillDialog(false)}
        handleAccept={() => handleFulfill(request)}
        title={`Fulfill ${request.userInfo.name}'s request?`}
        content={"Validating their request will validate their ticket and send it by email. This action is irreversible"}
      />
      <Modal
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box className="modal-style" sx={centered_flex_box}>
          <Box sx={{ ...centered_flex_box, flexDirection: "column", padding: 3 }}>
            <Typography fontWeight="bold" fontSize={24}>Payment Transfer Details</Typography>
            <Image width={"60%"} src={request.receipt} />
            <Typography fontSize={22}>Username: {request.instapayUser}</Typography>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
      >
        <Box
          sx={{
            ...centered_flex_box,
            p: { xs: 2, sm: 3 },
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", sm: "80%", md: "60%" },
              maxWidth: "720px",
              maxHeight: "80vh",
              overflowY: "auto",
              backgroundColor: "var(--platform-surface)",
              borderRadius: 2,
              boxShadow: 24,
              p: { xs: 2, sm: 3 },
            }}
          >
            <Typography fontWeight="bold" fontSize={{ xs: 20, sm: 24 }}>Buyer Details</Typography>
            {Object.keys(request.userInfo).map((info) => {
              return (
                <Typography fontSize={{ xs: 16, sm: 22 }} sx={{ wordBreak: "break-word" }}>
                  {formatInfoKey(info)}:{" "}
                  {info.toLowerCase().includes("link") ? (
                    <Link
                      href={request.userInfo[info]}
                      target="_blank"
                      rel="noreferrer"
                      underline="always"
                      sx={{ fontSize: { xs: 16, sm: 22 }, fontWeight: 500 }}
                    >
                      Open Link
                    </Link>
                  ) : (
                    request.userInfo[info]
                  )}
                </Typography>
              );
            })}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {
  acceptTicketRequest,
  fulfillTicketRequest,
  rejectTicketRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestRow);
